import { useRef, createContext } from "react";
import "./App.less";
import { Provider } from "react-redux";
import store from "./store";
import Routes from "./routes";
import { ConfigProvider, message } from "antd";
import { Empty } from "antd";
import emptyIcon from "./assets/images/smile_dark.png";
import CheckBrowser from "./components/CheckBrowser";
import liuliuaiWhileUrl from '@/assets/images/liuliuaiWhile.png';
import loadingPoint from '@/assets/images/loadingPoint.gif';
import '@/sensorsdata'

const { dispatch } = store;

const DefaultIcon = () => {
  return (
    <div
      style={{
        backgroundImage: `url(${emptyIcon})`,
        height: "100%",
        width: "100%",
        backgroundSize: "cover"
      }}
    ></div>
  );
};

const renderEmptyDom = () => {
  return (
    <Empty
      image={<DefaultIcon />}
      imageStyle={{
        height: 60,
        width: 60
      }}
      description={<span></span>}
    ></Empty>
  );
};

message.config({
  duration: 3,
  maxCount: 2,
});

const isSupport = CSS.supports("selector(:where(div))")

export const AppCtx = createContext(null)

function App() {
  const genBase64ImageRef = useRef(null); // 改图-获取base64图片(前端生图模式)
  const recordSaveParams = useRef({}); // 改图-保存记录状态(是否已保存，前端生图模式)
  const toastHandleRef = useRef({});
  
  return (
    <ConfigProvider renderEmpty={renderEmptyDom} autoInsertSpaceInButton={false} theme={{ token: { colorPrimary: '#27AE60' } }}>
      <div className="App">
        <div className="coverLoadView" id="coverLoadView">
          <div className="coverLoadViewBg"></div>
          <div style={{textAlign:'center', width: '100vw'}}>
            <div className="coverLoadViewTitle">
              <img src={liuliuaiWhileUrl} style={{width: '190px'}} alt="溜溜logo"/>
            </div>
            <div className="coverLoadViewSubTitle">
              <span style={{fontSize: '26px'}}>AI</span>
              <span style={{paddingRight:'18px'}}>赋能</span>
              <span>共创未来</span>
            </div>
          </div>
          <div className="loadingBottomWrap">
            <div className="loadingBarView">
              <div className="bear-wrap"><div class="mss-bear mss-lu4"></div></div>
              <div className="loadingBar"></div>
              <div className="loadingBarEmtry"></div>
              <div className="loadingBarText">
                <span style={{opacity:0.6}}>loading</span>
                <img style={{position:'relative',bottom:'-5px'}} src={loadingPoint}/>
              </div>
            </div>
          </div>
        </div>
        <Provider store={store}>
          <AppCtx.Provider value={{ genBase64ImageRef, recordSaveParams, toastHandleRef }}>
            <Routes />
            {!isSupport && <CheckBrowser/>}
          </AppCtx.Provider>
        </Provider>
      </div>
    </ConfigProvider>
  );
}

export default App;
